import { useEffect } from 'react';
import { disableNetwork, enableNetwork } from 'firebase/firestore';
import { db } from '../firebase';

const IDLE_TIMEOUT = 60000; // 1 min after going to background

export function useFirestoreIdleManager() {
  useEffect(() => {
    let timeoutId = null;
    let networkDisabled = false;

    const handleVisibility = async () => {
      if (document.hidden) {
        timeoutId = setTimeout(async () => {
          try {
            await disableNetwork(db);
            networkDisabled = true;
          } catch (e) { /* ignore */ }
        }, IDLE_TIMEOUT);
      } else {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
        if (networkDisabled) {
          try {
            await enableNetwork(db);
            networkDisabled = false;
          } catch (e) { /* ignore */ }
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);
}
